// extracted by mini-css-extract-plugin
export default {"component":"DacCost_component__z0Oy1"};